export const availableLocales = [
  'af',
  'am',
  'ar',
  'az',
  'be',
  'bg',
  'bn',
  'bs',
  'ca',
  'cr',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'es-419',
  'et',
  'eu',
  'fa',
  'fi',
  'fil',
  'fr',
  'fr-ca',
  'gl',
  'gu',
  'hi',
  'hr',
  'hu',
  'hy',
  'id',
  'is',
  'it',
  'iw',
  'ja',
  'ka',
  'kk',
  'km',
  'kn',
  'ko',
  'ky',
  'lo',
  'lt',
  'lv',
  'mk',
  'ml',
  'mn',
  'mr',
  'ms',
  'my',
  'ne',
  'nl',
  'no',
  'pa',
  'pl',
  'pt',
  'pt-br',
  'ro',
  'ru',
  'si',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'tr',
  'ua',
  'ur',
  'uz',
  'vi',
  'zh-cn',
  'zh-hk',
  'zh-tw',
  'zu',
]
